document.addEventListener("DOMContentLoaded", function () {
  attachVideo();
});

function attachVideo() {
  var modal = document.getElementById("videoModal");
  var closeBtn = document.querySelector(".video-modal-close");
  var videoFrame = document.getElementById("videoFrame");
  if (modal) {
    document.querySelectorAll(".video-button").forEach(function (button) {
      button.addEventListener("click", function () {
        var videoUrl = this.getAttribute("data-video-url");
        videoFrame.src = videoUrl; //+ "?autoplay=1"; // Add autoplay parameter to URL;
        modal.style.display = "flex";
      });
    });

    closeBtn.addEventListener("click", function () {
      modal.style.display = "none";
      videoFrame.src = ""; // Stop the video when modal closes
    });

    window.addEventListener("click", function (event) {
      if (event.target == modal) {
        modal.style.display = "none";
        videoFrame.src = ""; // Stop the video when modal closes
      }
    });
  }
};